module.exports = __webpack_public_path__ + "img/gpay.f22819f8.png";